<mat-card class="importar-ubicaciones-container">
  <app-card-header
    title="Importar Ubicaciones desde CSV"
    icono="upload_file"
    [botonCerrar]="true"
    (cerrar)="close()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <!-- Overlay de carga -->
    @if (loading) {
      <div class="loading-overlay">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Procesando ubicaciones...</p>
      </div>
    }

    <div class="content" [class.disabled]="loading">
      <!-- Instrucciones -->
      <app-content-card title="Instrucciones de importación" icon="info">
        <div class="instrucciones">
          <p>
            El archivo CSV debe contener las siguientes columnas separadas por
            comas:
          </p>
          <div class="columnas-info">
            <div class="columna-item">
              <strong>1. Fecha:</strong>
              Fecha del registro
            </div>
            <div class="columna-item">
              <strong>2. Nom. Elemento:</strong>
              Nombre del elemento
            </div>
            <div class="columna-item">
              <strong>3. Puesta ID:</strong>
              Identificador de puesta
            </div>
            <div class="columna-item">
              <strong>4. Dirección Mac:</strong>
              Debe coincidir con el DevEUI de la luminaria
            </div>
            <div class="columna-item">
              <strong>5. Longitud:</strong>
              Coordenada de longitud (-180 a 180)
            </div>
            <div class="columna-item">
              <strong>6. Latitud:</strong>
              Coordenada de latitud (-90 a 90)
            </div>
          </div>

          <div class="formato-info">
            <p class="subtitulo">Formato requerido:</p>
            <ul>
              <li>
                <strong>Separador:</strong>
                Coma (,)
              </li>
              <li>
                <strong>Coordenadas:</strong>
                Números decimales (ej: -56.1234, -34.5678)
              </li>
              <li>
                <strong>Dirección Mac:</strong>
                Debe coincidir exactamente con el DevEUI de la luminaria
              </li>
            </ul>
          </div>

          <div class="ejemplo-info">
            <p class="subtitulo">Ejemplo:</p>
            <code class="ejemplo-csv">
              2024-01-15,Luminaria 1,001,A84041FFFF123456,-56.1234,-34.5678
              <br />
              2024-01-15,Luminaria 2,002,A84041FFFF789012,-56.1244,-34.5688
            </code>
          </div>
        </div>
      </app-content-card>

      <!-- Formulario -->
      @if (form) {
        <app-content-card title="Cargar archivo CSV" icon="upload_file">
          <form [formGroup]="form!" (ngSubmit)="onSubmit()" autocomplete="off">
            <!-- Opción Primera Línea Encabezado -->
            <div class="checkbox-container">
              <mat-checkbox
                color="primary"
                [(ngModel)]="primerLineaEncabezado"
                [ngModelOptions]="{ standalone: true }"
              >
                La primera línea contiene encabezados (se omitirá al procesar)
              </mat-checkbox>
            </div>

            <!-- Carga de Archivo -->
            <div class="upload-area">
              <input
                type="file"
                #fileInput
                accept=".csv,.txt"
                (change)="cargarCsv($event)"
                class="file-input"
              />
              <button
                irxBoton="secundario"
                type="button"
                (click)="fileInput.click()"
                class="upload-button"
              >
                <mat-icon>folder_open</mat-icon>
                Seleccionar archivo CSV
              </button>
              <p class="file-help-text">
                O pega el contenido directamente en el área de texto
              </p>
            </div>

            <!-- Área de Texto para CSV -->
            <div class="textarea-section">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Contenido del CSV</mat-label>
                <textarea
                  matInput
                  formControlName="csv"
                  rows="15"
                  placeholder="Pega aquí el contenido del CSV separado por comas
Ejemplo:
2024-01-15,Luminaria 1,001,A84041FFFF123456,-56.1234,-34.5678
2024-01-15,Luminaria 2,002,A84041FFFF789012,-56.1244,-34.5688"
                  class="csv-textarea"
                ></textarea>

                @if (form.get('csv')?.hasError('required')) {
                  <mat-error>El contenido del CSV es requerido</mat-error>
                }
                @if (form.get('csv')?.hasError('error')) {
                  <mat-error>
                    {{ getErrorMessage() }}
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <!-- Información de Estado -->
            @if (form.get('csv')?.value) {
              <div class="status-info">
                <div class="status-item">
                  <mat-icon>assignment</mat-icon>
                  <span>
                    Líneas a procesar:
                    {{ separarEnLineas(form.get('csv')?.value)?.length || 0 }}
                  </span>
                </div>
                @if (form.get('csv')?.valid) {
                  <div class="status-item">
                    <mat-icon class="success-icon">check_circle</mat-icon>
                    <span>Formato válido</span>
                  </div>
                }
                @if (form.get('csv')?.invalid) {
                  <div class="status-item">
                    <mat-icon class="error-icon">error</mat-icon>
                    <span>Revisar errores de formato</span>
                  </div>
                }
              </div>
            }
          </form>
        </app-content-card>
      }
    </div>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button
      irxBoton="secundario"
      type="button"
      (click)="close()"
      [disabled]="loading"
    >
      Cancelar
    </button>
    <button
      irxBoton="principal"
      type="button"
      (click)="onSubmit()"
      [disabled]="!form?.valid || loading"
    >
      @if (!loading) {
        <mat-icon>upload</mat-icon>
      }
      @if (loading) {
        <mat-spinner diameter="20"></mat-spinner>
      }
      Importar ubicaciones
    </button>
  </mat-card-actions>
</mat-card>
